<div class="flex flex-col gap-4 h-full" *transloco="let t">
   <h2>{{ t('user.title') }}</h2>
</div>